import { ErrorInfo, PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';
import { ServiceUnavailable } from './pages/ServiceUnavailable';

export const AppErrorBoundary = ({ appName, children }: AppErrorBoundaryProps) => {
  const location = useLocation();
  // const [pushError] = usePushErrorMutation();

  const handleError = (error: unknown, info: ErrorInfo) => {
    console.error({ error, info });

    if (import.meta.env.MODE === 'dev') return;

    return; // TODO Retirer pour pousser l'erreur vers le serveur

    // pushError({
    //   app: appName,
    //   reactScope: 'inside',
    //   url: location.pathname,
    //   timestamp: Date.now(),
    //   userAgent: window.navigator.userAgent,
    //   message: error.message,
    //   stack: error?.stack,
    //   info,
    // } satisfies PushErrorMutationArgs);
  };

  return <ErrorBoundary FallbackComponent={ServiceUnavailable}
                        onError={handleError}
                        resetKeys={[location.pathname]}>
    {children}
  </ErrorBoundary>;
};

interface AppErrorBoundaryProps extends PropsWithChildren {
  appName: string;
}